import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaBooleanNode } from './TypedNode'
import { SchemaBooleanModel } from './ViewModel'

export const SchemaBooleanPlugin = createSchemaPlugin(
  'Schema.Boolean',
  SchemaBooleanModel,
  SchemaBooleanNode
)
